import { render, staticRenderFns } from "./MarkdownModal.vue?vue&type=template&id=3f5ba850&scoped=true"
import script from "./MarkdownModal.vue?vue&type=script&lang=js"
export * from "./MarkdownModal.vue?vue&type=script&lang=js"
import style0 from "./MarkdownModal.vue?vue&type=style&index=0&id=3f5ba850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5ba850",
  null
  
)

export default component.exports